export default __webpack_public_path__ + "static/media/New Agents Hero Img.fbf23bca.png";